import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../_actions/dataActions";
import * as userActions from "../../../_actions/userActions";
import Wrapper from "../../../_hoc/Wrapper";
import Select from "../../../_components/UI/Select";
import Input from "../../../_components/UI/Input";
import Button from "../../../_components/UI/Button";
import ReactPhoneInput from "react-phone-input-2";
import "./index.css";
import GenderSelect from "./GenderSelect";
import getCreatedBy from "../../../_selectors/dataSelectors/getCreatedBy";

class AccountCreatedModal extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.name) {
      if (prevState.name === "") {
        return { name: nextProps.name, isFemale: nextProps.isFemale };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  state = {
    isFemale: true,
    selectedCreatedBy: {
      label: "Self",
      value: "self"
    },
    name: ""
  };
  componentDidMount() {
    const { createdBy, getCreatedByData } = this.props;
    if (createdBy.length === 0) {
      getCreatedByData();
    }
  }
  changeGender = isFemale => {
    this.setState({ isFemale });
  };
  save = () => {
    const { isFemale, selectedCreatedBy, name } = this.state;
    const { updateProfile, onClose, disableGender } = this.props;
    if (disableGender) {
      updateProfile({ createdBy: selectedCreatedBy.value, name });
    } else {
      updateProfile({ isFemale, createdBy: selectedCreatedBy.value, name });
    }

    if (onClose) {
      onClose();
    }
  };
  render() {
    const { isFemale, selectedCreatedBy, name } = this.state;
    const { createdBy, disableGender } = this.props;
    return (
      <Wrapper>
        <h2>Tell us about Yourself before you proceed</h2>
        <GenderSelect
          male={!isFemale}
          onChange={this.changeGender}
          disable={disableGender}
        />
        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-sm-12">
              <Input
                value={name}
                onChange={value => {
                  this.setState({ name: value });
                }}
                label={<Wrapper>Full Name</Wrapper>}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <Select
                label={<Wrapper>Account Created By</Wrapper>}
                selected={selectedCreatedBy}
                options={createdBy}
                onChange={value => {
                  this.setState({ selectedCreatedBy: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Button
              label="Continue"
              style={{ display: "block", margin: "0 auto", marginTop: "10px" }}
              primary
              small
              clean
              onClick={this.save}
              disabled={name ? false : true}
            />
          </div>
        </div>
      </Wrapper>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  createdBy: getCreatedBy(state)
});
const mapDispatchToProps = dispatch => ({
  getCreatedByData: () => dispatch(dataActions.getCreatedBy()),
  updateProfile: payload => dispatch(userActions.updateUserGender(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountCreatedModal);



// WEBPACK FOOTER //
// ./src/_components/UI/AccountCreatedModal/index.js